export default __webpack_public_path__ + "static/media/login-facebook-fr.d1929645.png";